import type { ReactNode } from 'react';
import { Box, Heading, Stack, PageBlock } from 'braid-design-system';

interface SectionProps {
  tone: 'brandAccent' | 'surface' | 'neutralLight';
  title?: string;
  children?: ReactNode;
  id?: string;
}
export function Section({ tone, title, children, id }: SectionProps) {
  return (
    <Box
      id={id}
      paddingY="xxxlarge"
      background={tone}
      style={id ? { scrollMarginTop: '88px' } : undefined}
    >
      <PageBlock width="large">
        <Stack space="xxlarge">
          {title ? (
            <Heading level="1" component="h2" weight="weak">
              {title}
            </Heading>
          ) : null}
          <Box>{children}</Box>
        </Stack>
      </PageBlock>
    </Box>
  );
}
